function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.0703 0H22.9293V6.04166H21.0703V0ZM33.0087 1.89237L31.4403 0.894473L28.1876 6.00672L29.756 7.00461L33.0087 1.89237ZM13.0245 0.895924L16.2777 6.00817L14.7093 7.00625L11.456 1.89401L13.0245 0.895924ZM43.9823 35.3098V22.1015L44 22.0818L43.9823 22.0659V22.0288H43.9412L34.4402 13.4775H9.55976L0.0588343 22.0288H0.0176158V22.0659L0 22.0818L0.0176158 22.1014V35.3098C0.0176158 36.8252 1.25 38.0576 2.76541 38.0576H41.2345C42.7499 38.0576 43.9823 36.8252 43.9823 35.3098ZM14.6725 22.0288H2.83727L10.2736 15.3365H33.7264L41.1627 22.0288H29.3274V22.9448C29.3274 25.2176 27.4786 27.0665 25.2057 27.0665H18.7942C16.5213 27.0665 14.6725 25.2176 14.6725 22.9448V22.0288ZM1.84948 23.8607V35.3098C1.84948 35.815 2.26027 36.2258 2.76541 36.2258H41.2345C41.7396 36.2258 42.1504 35.815 42.1504 35.3098V23.8607H31.0892C30.6473 26.7106 28.177 28.8983 25.2057 28.8983H18.7942C15.8229 28.8983 13.3527 26.7106 12.9107 23.8607H1.84948Z",
  fill: "currentColor"
});

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.9cb5ab07.svg";
export { ForwardRef as ReactComponent };